import React from 'react'
import { LoaderThree } from './LoaderThree'

export const Loader = ({ size = '40px', color = '#63a1a0', height }) => {
  return <LoaderThree color={color} size={size} height={height} />
}
